import React from 'react';
import {
	ApButtonMain,
	ApButtonTab,
	ApSecondaryNav,
	ApButtonIcon,
} from '@alixpartners/ui-components';
import { useLocation, NavLink } from 'react-router-dom';

import {
	INITIATIVE_TYPES,
	ITEMS_TYPE,
	TAXONOMY_DATA,
	TAXONOMY_GROUPS,
} from '../utils';
import { NavFilter } from 'components/NavFilter';

import {
	Divider,
	TabsWrapper,
	OptionLabel,
	Label,
	RightWrapper,
} from './SecondaryNav.styles';

export const ROOT_ROUTE = '/initiatives';

const TABS_CONFIG = [
	{
		path: `${ROOT_ROUTE}/categories`,
		name: 'categories',
		label: 'Categories & Vendors',
	},
	// {
	// 	path: `${ROOT_ROUTE}/payment`,
	// 	name: 'payment',
	// 	label: 'Payment Terms',
	// },
];

export const SecondaryNav = ({
	creators,
	waves,
	type,
	wave,
	taxonomy,
	creator,
	onCreate,
	onFilterChange,
	isPaymentTerms,
	onExport,
	isPortco,
}) => {
	const location = useLocation();
	const categoriesTypesOptions = [...INITIATIVE_TYPES[ITEMS_TYPE.CATEGORY]];
	const othersOption = categoriesTypesOptions.pop();
	const typesOptions = isPaymentTerms
		? [
				...INITIATIVE_TYPES[ITEMS_TYPE.PT_HARMONIZATION],
				...INITIATIVE_TYPES[ITEMS_TYPE.PT_IMPROVEMENT],
		  ]
		: [
				...categoriesTypesOptions,
				...INITIATIVE_TYPES[ITEMS_TYPE.VENDOR],
				othersOption,
		  ];

	const wavesOptions = waves.map(wave => ({
		label: wave.name,
		value: wave.id.toString(),
	}));
	const creatorsOptions = creators.map(creator => ({
		label: creator.name,
		labelNode: <OptionLabel>{creator.name}</OptionLabel>,
		value: creator.name,
	}));

	return (
		<ApSecondaryNav
			left={
				<TabsWrapper>
					{TABS_CONFIG.map(({ label, path, disabled }) => (
						<NavLink to={path} key={path} disabled={disabled}>
							<ApButtonTab
								isSelected={location.pathname.includes(path)}
								disabled={disabled}
							>
								{label}
							</ApButtonTab>
						</NavLink>
					))}
				</TabsWrapper>
			}
			right={
				<RightWrapper>
					<NavFilter
						onChange={selected => {
							onFilterChange({
								taxonomy: selected,
							});
						}}
						selected={taxonomy}
						name={'Initiative taxonomy'}
						label={
							taxonomy && taxonomy.length > 0 ? 'Taxonomies' : 'All taxonomies'
						}
						options={TAXONOMY_DATA}
						groupLabels={TAXONOMY_GROUPS}
						delay={0}
					/>
					<NavFilter
						onChange={selected => {
							onFilterChange({
								initiativeType: selected,
							});
						}}
						selected={type}
						name={'Initiative type'}
						label={
							type && type.length > 0 ? 'Initiative types' : 'All initiatives'
						}
						options={typesOptions}
						delay={0}
					/>
					<NavFilter
						onChange={selected => {
							onFilterChange({
								initiativeWave: selected,
							});
						}}
						selected={wave}
						name={'Wave'}
						label={wave && wave.length > 0 ? 'Waves' : 'All waves'}
						options={wavesOptions}
						delay={0}
					/>
					{!isPortco && (
						<NavFilter
							onChange={selected => {
								onFilterChange({
									initiativeCreator: selected,
								});
							}}
							selected={creator}
							name={'Creator'}
							label={
								creator && creator.length > 0 ? 'Creators' : 'All creators'
							}
							options={creatorsOptions}
							delay={0}
						/>
					)}
					<Divider />
					<Label>Export</Label>
					<ApButtonIcon iconName="download" onClick={onExport} />
					<Divider />
					<ApButtonMain iconName="baseline_add" onClick={onCreate}>
						Create initiative
					</ApButtonMain>
				</RightWrapper>
			}
		/>
	);
};

export default SecondaryNav;
